module.exports = __webpack_public_path__ + "img/windPressure.e73360bc.png";